module.exports = __webpack_public_path__ + "img/icon-scroll4.486a26f6.png";